
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sci-pub-catalogs/rsci",
      function () {
        return require("private-next-pages/sci-pub-catalogs/rsci.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sci-pub-catalogs/rsci"])
      });
    }
  